// extracted by mini-css-extract-plugin
module.exports = {"w164mbeb":"w164mbeb"};